import React, { useEffect } from 'react';
import {
  Container,
  ListGroup,
  ListGroupItem,
  Button,
  Spinner,
} from 'reactstrap';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { connect } from 'react-redux';
import { getItems, deleteItem } from '../flux/actions/itemActions';
import { IItemReduxProps, IShoppingList } from '../types/interfaces';

const ShoppingList = ({
  getItems,
  item,
  isAuthenticated,
  deleteItem,
}: IShoppingList) => {
  useEffect(() => {
    getItems();
  }, [getItems]);

  const handleDelete = (id: string) => {
    deleteItem(id);
  };

  const { items, loading } = item;

  return (
    <Container>
      {loading ? (
        <div style={{ textAlign: 'center', margin: '2rem' }}>
          <Spinner color="primary" /> Loading...
        </div>
      ) : (
        <ListGroup>
          <TransitionGroup className="shopping-list">
            {items.map(({ _id, name }) => (
              <CSSTransition key={_id} timeout={500} classNames="fade">
                <ListGroupItem>
                  {isAuthenticated && (
                    <>
                      <Button
                        className="remove-btn"
                        color="danger"
                        size="sm"
                        onClick={() => handleDelete(_id)}
                        style={{ marginRight: '0.5rem' }}
                      >
                        &times;
                      </Button>
                    </>
                  )}
                  {name}
                </ListGroupItem>
              </CSSTransition>
            ))}
          </TransitionGroup>
        </ListGroup>
      )}
    </Container>
  );
};

const mapStateToProps = (state: IItemReduxProps) => ({
  item: state.item,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { getItems, deleteItem })(ShoppingList);
